<template>
  <v-container fluid>
    <v-row justify="space-between" align="center" class="px-10">
      <!-- <v-col cols="12" sm="12" md="12"> -->
      <v-col cols="12" sm="12" class="pa-0">
        <v-btn color="primary" icon size="20" @click="goBack()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <div
          v-if="user.photoURL"
          class="rounded-circle avatar-profile-image mx-auto"
          :style="`background-image:url(${user.photoURL})`"
        ></div>
        <template v-else>
          <div class="text-center">
            <img
              class="rounded-circle avatar-profile-image"
              :src="require('@/assets/default-avatar.png')"
            />
          </div>
        </template>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <h3 class="secondary--text">
          <span class="font-weight-light">Name:</span> {{ user.firstName }}
          {{ user.lastName }}
        </h3>
        <h3 class="secondary--text">
          <span class="font-weight-light">Nickname:</span> {{ user.nickname }}
        </h3>
        <h3 class="secondary--text">
          <span class="font-weight-light">Email:</span> {{ user.email }}
        </h3>
        <h3 class="secondary--text">
          <span class="font-weight-light">Creation Date:</span>
          {{
            getParsedDate(user.creationTime ? user.creationTime?.toDate() : "")
          }}
        </h3>
        <h3 class="secondary--text">
          <span class="font-weight-light">Last login:</span>
          {{
            typeof user.lastLogin === "string"
              ? user.lastLogin
              : user.lastLogin?.toDate().toLocaleDateString()
          }}
        </h3>
        <h3 class="secondary--text">
          <span class="font-weight-light">Privilege:</span>
          {{ verifyPrivilege() }}
        </h3>
      </v-col>
      <v-col cols="12" sm="12" md="4" class="text-center">
        <v-btn
          small
          color="secondary"
          class="mr-2"
          @click="openModal('restore', user.email, user)"
          >Restore Password</v-btn
        >

        <!-- </v-col>
      <v-col cols="12" sm="12" md="1" class="text-center"> -->
        <v-btn
          small
          color="secondary"
          class="mr-2"
          @click="openModal('validate', user.email, user)"
          >Validate Email</v-btn
        >
        <!-- </v-col>
      <v-col cols="12" sm="12" md="1" class="text-center"> -->
        <v-btn
          small
          color="secondary"
          width="150"
          @click="changeRouteSendNotification()"
          >Send Notification</v-btn
        >
      </v-col>
      <v-col cols="12" sm="12" md="2">
        <!-- <h3 class="text-center font-weight-light secondary--text">Role</h3> -->
        <v-btn
          v-if="getAdmin.adminLevel === 3"
          small
          color="primary"
          class="mr-2"
          @click="openDialogManageAllowedViews()"
          >Manage allowed views</v-btn
        >
        <template v-else>
          <h3 class="text-center font-weight-light secondary--text">Role</h3>
          <h4 class="text-center primary--text pa-5" v-if="user">
            {{ levelProps.find((r) => r.value === user.adminLevel).level }}
          </h4>
        </template>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <h3 class="text-left font-weight-light secondary--text">Enabled</h3>
        <v-switch
          class="mx-auto"
          color="primary"
          :input-value="!user.disabled"
          :disabled="user.adminLevel >= 1"
          @click="openModal('disable', user.email, user)"
          readonly
          flat
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <h3 class="text-left font-weight-light secondary--text">Coach</h3>
        <v-switch
          v-model="user.isCoach"
          class="mx-auto"
          color="primary"
          :disabled="loadingCoach"
          :loading="loadingCoach"
          @change="changeCoachStatus()"
          flat
        ></v-switch>
      </v-col>
      <!-- </v-col> -->
    </v-row>

    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">Profile preferences</h3>
        <p class="text-caption grey--text mb-2">
          Everything the user set up in the app. Anything not configured shows
          as <span class="font-italic">missing</span>.
        </p>
        <div v-if="user" class="prefs-columns">
          <v-card
            v-for="grupo in profilePreferences"
            :key="grupo.title"
            class="elevation-4 pa-4 prefs-card"
          >
            <div
              class="text-overline grey--text text--darken-1 mb-1"
              style="letter-spacing: 1px"
            >
              {{ grupo.title }}
            </div>
            <div
              v-for="(pref, i) in grupo.fields"
              :key="pref.key"
              class="d-flex align-baseline py-1"
              :class="{ 'prefs-row-divider': i > 0 }"
            >
              <span class="text-body-2 grey--text text--darken-1 prefs-label">{{
                pref.label
              }}</span>
              <span
                class="text-body-2 font-weight-medium prefs-value"
                :class="pref.missing ? 'grey--text font-italic font-weight-regular' : 'secondary--text'"
                >{{ pref.value }}</span
              >
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <!-- TEMPORALLY COMMENT FOR FIX STADISTICS PROBLEMS-->
    <!-- <v-row justify="start" align="center">
      <v-col cols="12" sm="12" md="3">
        <v-card class="rounded-xl my-2 mx-auto d-flex flex-column justify-center" elevation="5" width="270" height="135">
          <v-card-title class="font-weight-bold secondary--text"
            >{{ user.savesUser && user.savesUser.freeStyleSaves ? user.savesUser.freeStyleSaves.length : 0 }} Freestyle sessions</v-card-title
          >
          <v-card-subtitle class="pb-0"
            >{{ user.savesUser && user.savesUser.freeStyleSaves ? getTimeWorkouts(user.savesUser.freeStyleSaves) : '0 seconds' }} in Freestyle sessions</v-card-subtitle
          >
          <v-card-text v-if="user.savesUser && user.savesUser.freeStyleSaves && user.savesUser.freeStyleSaves.length > 0" class="font-weight-bold primary--text"
            >From {{ rangeDates(user.savesUser.freeStyleSaves).minDate }} to {{ rangeDates(user.savesUser.freeStyleSaves).maxDate }}
          </v-card-text>
          <template v-else>
            <v-card-text class="font-weight-bold primary--text"
              >Has not completed any yet
            </v-card-text>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-card class="rounded-xl my-2 mx-auto d-flex flex-column justify-center" elevation="5" width="270" height="135">
          <v-card-title class="font-weight-bold secondary--text"
            >{{ user.savesUser && user.savesUser.buildYourOwnSaves ? user.savesUser.buildYourOwnSaves.length : 0 }} Build Your Own</v-card-title
          >
          <v-card-subtitle class="pb-0"
            >{{ user.savesUser && user.savesUser.buildYourOwnSaves ? getTimeWorkouts(user.savesUser.buildYourOwnSaves) : '0 seconds' }} / {{ user.savesUser && user.savesUser.buildYourOwnSaves ? getCalsWorkouts(user.savesUser.buildYourOwnSaves) : 0 }} Cal / {{ user.savesUser && user.savesUser.buildYourOwnSaves ? getExercisesMadedWorkouts(user.savesUser.buildYourOwnSaves) : 0 }} Exercises</v-card-subtitle
          >
          <v-card-text v-if="user.savesUser && user.savesUser.buildYourOwnSaves && user.savesUser.buildYourOwnSaves.length > 0" class="font-weight-bold primary--text"
            >From {{ rangeDates(user.savesUser.buildYourOwnSaves).minDate }} to {{ rangeDates(user.savesUser.buildYourOwnSaves).maxDate }}
          </v-card-text>
          <template v-else>
            <v-card-text class="font-weight-bold primary--text"
              >Has not completed any yet
            </v-card-text>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-card class="rounded-xl my-2 mx-auto d-flex flex-column justify-center" elevation="5" width="270" height="135">
          <v-card-title class="font-weight-bold secondary--text"
            >{{ user.savesUser && user.savesUser.proWorkOutSaves ? user.savesUser.proWorkOutSaves.length : 0 }} ProWorkouts</v-card-title
          >
          <v-card-subtitle class="pb-0"
            >{{ user.savesUser && user.savesUser.proWorkOutSaves ? getTimeWorkouts(user.savesUser.proWorkOutSaves) : '0 seconds' }} / {{ user.savesUser && user.savesUser.proWorkOutSaves ? getCalsWorkouts(user.savesUser.proWorkOutSaves) : 0 }} Cal / {{ user.savesUser && user.savesUser.proWorkOutSaves ? getExercisesMadedWorkouts(user.savesUser.proWorkOutSaves) : 0 }} Exercises</v-card-subtitle
          >
          <v-card-text v-if="user.savesUser && user.savesUser.proWorkOutSaves && user.savesUser.proWorkOutSaves.length > 0" class="font-weight-bold primary--text"
            >From {{ rangeDates(user.savesUser.proWorkOutSaves).minDate }} to {{ rangeDates(user.savesUser.proWorkOutSaves).maxDate }}
          </v-card-text>
          <template v-else>
            <v-card-text class="font-weight-bold primary--text"
              >Has not completed any yet
            </v-card-text>
          </template>
        </v-card>
      </v-col>
        <v-col cols="12" sm="12" md="3">
        <v-card class="rounded-xl my-2 mx-auto d-flex flex-column justify-center" elevation="5" width="270" height="135">
          <v-card-title class="font-weight-bold secondary--text"
            >{{ user.savesUser && user.savesUser.proTrainingSaves ? user.savesUser.proTrainingSaves.length : 0 }} ProTrain sessions</v-card-title
          >
          <v-card-subtitle class="pb-0"
            >{{ user.savesUser && user.savesUser.proTrainingSaves ? getTimeWorkoutsProTrainers(user.savesUser.proTrainingSaves) : '0 seconds' }} in ProTrain sessions</v-card-subtitle
          >
          <v-card-text v-if="user.savesUser && user.savesUser.proTrainingSaves && user.savesUser.proTrainingSaves.length > 0" class="font-weight-bold primary--text"
            >From {{ rangeDates(user.savesUser.proTrainingSaves).minDate }} to {{ rangeDates(user.savesUser.proTrainingSaves).maxDate }}
          </v-card-text>
          <template v-else>
            <v-card-text class="font-weight-bold primary--text"
              >Has not completed any yet
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">Builds your own(sessions)</h3>
        <v-data-table
          v-if="user"
          :search="search"
          :loading="loading"
          :headers="headers"
          :items="user.savesUser.sessions"
          :items-per-page="5"
          item-key="name"
          fixed-header
          class="elevation-4"
        >
        <template v-slot:[`item.exercises`]="{ item }">
            {{ item.exercises.length }}
        </template>
        </v-data-table>
      </v-col>
    </v-row> -->
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <v-row justify="start" align="center">
          <v-col cols="12" sm="6" md="3">
            <h3 class="secondary--text my-5">Workout Results</h3>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <!-- vue-json-to-csv dispara la descarga al click en su contenido -->
            <vue-json-to-csv
              v-if="userResults.length > 0"
              :json-data="resultsCsvData"
              :csv-title="resultsCsvTitle"
            >
              <v-btn small color="primary">
                <v-icon small left>mdi-download</v-icon>
                Export CSV
              </v-btn>
            </vue-json-to-csv>
            <v-btn v-else small color="primary" disabled>
              <v-icon small left>mdi-download</v-icon>
              Export CSV
            </v-btn>
          </v-col>
        </v-row>

        <!-- Totales all-time (mismos acumuladores que la app) -->
        <v-row v-if="resultsAnalytics" class="mb-2" dense>
          <v-col
            v-for="stat in resultsSummaryCards"
            :key="stat.label"
            cols="6"
            sm="4"
            md="2"
          >
            <v-card class="rounded-lg text-center py-3" elevation="4">
              <div class="text-caption text-uppercase secondary--text">
                {{ stat.label }}
              </div>
              <div class="text-h6 primary--text font-weight-bold">
                {{ stat.value }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Lista de resultados (los 50 más recientes). Click en fila → detalle -->
        <v-data-table
          :loading="loadingResults"
          loading-text="Loading workout results..."
          no-data-text="No workout results found"
          :headers="headersResults"
          :items="userResults"
          :items-per-page="10"
          item-key="id"
          fixed-header
          class="elevation-4 results-table"
          @click:row="openResultModal"
        >
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ formatResultDate(item.createdAt) }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ getResultName(item) }}
          </template>
          <template v-slot:[`item.mxp`]="{ item }">
            {{ formatResultNumber(item.mxp) }}
          </template>
          <template v-slot:[`item.cals`]="{ item }">
            {{ formatResultNumber(item.cals) }}
          </template>
          <template v-slot:[`item.totalDistance`]="{ item }">
            {{ formatResultNumber(item.totalDistance) }}
          </template>
          <template v-slot:[`item.totalWeight`]="{ item }">
            {{ formatResultNumber(item.totalWeight) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon small color="primary" @click.stop="openResultModal(item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- TEMPORALLY COMMENT FOR FIX STADISTICS PROBLEMS-->
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">Achievements Unlocked</h3>
        <v-data-table
          v-if="user"
          :loading="loading"
          :headers="headersAchievementsEarned"
          :items="achievementsGetted"
          :items-per-page="5"
          fixed-header
          class="elevation-4"
        >
          <template v-slot:[`item.image`]="{ item }">
            <img :src="item.ref.icon.link" width="30" height="30" />
          </template>
          <template v-slot:[`item.ref`]="{ item }">
            {{ item.ref.name }}
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ timestampToStringDate(item.createdAt) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <v-row justify="start" align="center">
          <v-col cols="12" sm="6" md="2">
            <h3 class="secondary--text my-5">Subscriptions History</h3>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-btn
              v-if="getAdmin.adminLevel >= 1"
              small
              color="primary"
              @click="openDialogAddSubscription()"
            >
              <v-icon>mdi-plus</v-icon>
              Add Manually Subscription
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-if="user"
          :loading="loading"
          :headers="headersSubscriptions"
          :items="subscriptionsGetted"
          :items-per-page="5"
          item-key="id"
          fixed-header
          class="elevation-4"
        >
          <template v-slot:[`item.duration.quantity`]="{ item }">
            <span v-if="item.duration && item.duration.quantity && item.duration.interval">
              <!-- Datos nuevos: quantity e interval en duration -->
              {{ item.duration.quantity }} {{ item.duration.interval }}
            </span>
            <span v-else-if="item.typeSubscription && item.typeSubscription.duration && item.typeSubscription.duration.quantity && item.typeSubscription.duration.interval">
              <!-- Datos existentes: quantity e interval en typeSubscription -->
              {{ item.typeSubscription.duration.quantity }} {{ item.typeSubscription.duration.interval }}
            </span>
            <span v-else-if="item.duration && item.duration.startDate && item.duration.endDate" class="text-caption grey--text">
              <!-- Fallback: calcular duración basada en fechas -->
              {{ calculateDurationFromDates(item.duration.startDate, item.duration.endDate) }}
            </span>
            <span v-else class="text-caption grey--text">
              N/A
            </span>
          </template>
          <template v-slot:[`item.duration.startDate`]="{ item }">
            {{ timestampToStringDate(item.duration.startDate) }}
          </template>
          <template v-slot:[`item.duration.endDate`]="{ item }">
            {{ timestampToStringDate(item.duration.endDate) }}
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <h1
              v-if="user.activeSubscription?.ref?.id === item.id"
              :class="
                user.activeSubscription.isPremium
                  ? 'success--text'
                  : 'red--text'
              "
            >
              •
            </h1>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">Receipt history</h3>
        <p class="text-caption grey--text mb-2">
          Each attempt to validate a store receipt. The receipt itself is not shown.
        </p>
        <v-alert v-if="receiptsError" type="error" dense text class="mb-2">
          {{ receiptsError }}
        </v-alert>
        <v-data-table
          v-if="user"
          :loading="loadingReceipts"
          :headers="headersReceipts"
          :items="receiptsHistory"
          :items-per-page="10"
          item-key="id"
          show-expand
          single-expand
          :expanded.sync="expandedReceipts"
          fixed-header
          class="elevation-4"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-4 grey lighten-5">
              <v-row dense>
                <v-col
                  v-for="campo in receiptDetailFields(item)"
                  :key="campo.key"
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <div class="text-caption grey--text text--darken-1">
                    {{ campo.label }}
                  </div>
                  <div
                    class="text-body-2"
                    :class="campo.missing ? 'grey--text font-italic' : 'secondary--text'"
                  >
                    {{ campo.value }}
                  </div>
                </v-col>
              </v-row>
            </td>
          </template>
          <template v-slot:[`item.processedAt`]="{ item }">
            {{ timestampToStringDate(item.processedAt) }}
          </template>
          <template v-slot:[`item.result`]="{ item }">
            <span :class="receiptResultClass(item.result)">{{ item.result || "—" }}</span>
          </template>
          <template v-slot:[`item.originalTransactionId`]="{ item }">
            <span :title="item.originalTransactionId">{{ shortId(item.originalTransactionId) }}</span>
          </template>
          <template v-slot:[`item.errorDetails`]="{ item }">
            <span v-if="item.errorDetails" :title="item.errorDetails">{{ shortText(item.errorDetails) }}</span>
            <span v-else class="grey--text">—</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" v-if="isSubOwner">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">
          Family Members
          <v-btn
            small
            color="secondary"
            class="mr-2"
            @click="openDialogAddFamilyMember()"
            >Add Family Member</v-btn
          >
        </h3>
        <v-data-table
          v-if="user"
          :loading="loadingFamilyMembers"
          :headers="headersFamilyMembers"
          :items="familyMembers"
          :items-per-page="5"
          item-key="id"
          fixed-header
          class="elevation-4"
        >
          <template v-slot:[`item.photoURL`]="{ item }">
            <div
              v-if="item.photoURL || item.photo"
              class="rounded-circle avatar-profile-image mx-auto"
              :style="`background-image:url(${
                item.photoURL || item.photo
              }); width: 40px; height: 40px; background-size: cover;`"
            ></div>
            <template v-else>
              <div class="text-center">
                <img
                  class="rounded-circle avatar-profile-image"
                  :src="require('@/assets/default-avatar.png')"
                  style="width: 40px; height: 40px; object-fit: cover"
                />
              </div>
            </template>
          </template>
          <template v-slot:[`item.firstName`]="{ item }">
            {{ item.firstName }} {{ item.lastName }}
          </template>
          <template v-slot:[`item.email`]="{ item }">
            {{ item.email }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              small
              color="red"
              class="ml-2"
              :loading="removingFamilyMemberId === item.id"
              :disabled="removingFamilyMemberId === item.id"
              @click="openDialogRemoveFamilyMember(item)"
            >
              <v-icon color="white" small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">MAXPRO Devices</h3>
        <v-data-table
          v-if="user"
          :search="search"
          :loading="loading"
          :headers="headersMaxProDevices"
          :items="maxProDevices"
          :items-per-page="5"
          item-key="maxproMac"
          fixed-header
          class="elevation-4"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="11" md="11">
        <h3 class="secondary--text my-5">Mobile Devices</h3>
        <v-data-table
          v-if="user"
          :search="search"
          :loading="loading"
          :headers="headersDevices"
          :items="user.devicesInfo"
          :items-per-page="5"
          item-key="uuid"
          fixed-header
          class="elevation-4"
        >
          <template
            v-slot:[`item.lastUsed`]="{ item }"
            v-if="user.devicesInfo && user.devicesInfo.length > 0"
          >
            <span
              v-if="
                user.devicesInfo.map((dev) => dev.uuid).indexOf(item.uuid) ===
                user.devicesInfo.length - 1
              "
              class="primary--text text-h4"
              >•</span
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog.show" width="300" class="rounded-xl">
      <v-card>
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->

        <v-card-text class="pa-8 text-center" v-if="dialog.type === 'restore'"
          >Sure you want to reset {{ dialog.email }} password?</v-card-text
        >
        <v-card-text class="pa-8 text-center" v-if="dialog.type === 'validate'"
          >Are you sure you want to validate the email of
          {{ dialog.email }}?</v-card-text
        >
        <v-card-text class="pa-8 text-center" v-if="dialog.type === 'disable'"
          >Are you sure you want to
          {{ dialog.item.disabled ? "enable" : "disable" }} the account of
          {{ dialog.email }}?</v-card-text
        >

        <!-- <v-card-actions class="pa-0"> -->
        <!-- <v-spacer></v-spacer> -->

        <v-btn
          color="third"
          tile
          width="150"
          class="pa-0 text--secondary"
          @click="closeModal()"
          >No</v-btn
        >

        <v-btn
          color="primary"
          tile
          width="150"
          class="pa-0"
          @click="
            openDialogReAuth(
              'goActionMail',
              {},
              { type: dialog.type, email: dialog.email, item: dialog.item }
            )
          "
          >Yes</v-btn
        >
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRole.show"
      width="300"
      class="rounded-xl"
      persistent
    >
      <v-card>
        <v-card-text class="pa-8 text-center"
          >Are you sure you want change the role in MaxPro of the user:
          {{ user.email }}?</v-card-text
        >

        <v-btn
          color="third"
          tile
          width="150"
          class="pa-0 text--secondary"
          @click="closeModalRole()"
          >No</v-btn
        >

        <v-btn
          color="primary"
          tile
          width="150"
          class="pa-0"
          @click="
            openDialogReAuth('updateRoleUser', dialogRole.item, {
              type: '',
              email: user.email,
              item: dialogRole.item,
            })
          "
          >Yes</v-btn
        >
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogManageAllowedViews.show"
      width="800"
      class="rounded-xl"
    >
      <v-card class="pa-5" v-if="user.adminLevel !== ''">
        <v-card-actions class="pa-0">
          <v-btn icon color="red" @click="closeDialogManageAllowedViews()">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-row justify="start">
          <v-col cols="12" sm="12">
            <v-select
              v-if="getAdmin.adminLevel === 3"
              :items="levelProps"
              item-text="level"
              ref="selectRole"
              :value="user.adminLevel"
              dense
              solo
              class="mx-auto secondary--text"
              style="width: 80%"
              @change="changeRange"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            v-for="(route, index) in getRoutesNames()"
            :key="index"
          >
            <v-checkbox
              v-model="allowedRoutes"
              :label="route"
              :value="route"
            ></v-checkbox>
          </v-col>
        </v-row>
        <div class="text-right">
          <v-btn color="primary" small @click="updateViewsAllowed()">
            Save
          </v-btn>
        </div>
      </v-card>
      <template v-else>
        <v-card class="pa-5">
          <v-card-actions class="pa-0">
            <v-btn icon color="red" @click="closeDialogManageAllowedViews()">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
          <h3 class="text-center mb-4 font-weight-light secondary--text">
            This user does not have access to the Dashboard, you can change it
            here
          </h3>
          <v-select
            v-if="getAdmin.adminLevel === 3"
            :items="levelProps"
            item-text="level"
            ref="selectRole"
            :value="user.adminLevel"
            dense
            solo
            class="mx-auto secondary--text"
            style="width: 80%"
            @change="changeRange"
          ></v-select>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog
      v-model="dialogAddSubscription.show"
      width="800"
      class="rounded-xl"
    >
      <v-card class="pa-5">
        <v-card-actions class="pa-0">
          <v-btn icon color="red" @click="closeDialogAddSubscription()">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <h3 class="secondary--text mt-2">
                Add manually Subscription to {{ user.firstName }}
                {{ user.lastName }}
              </h3>
            </v-col>
            <!-- <v-col cols="4">
              <p class="secondary--text pb-1">Currency</p>
              <v-select
                v-model="dialogAddSubscription.subscription.billing.currency"
                :items="currienciesList"
                item-text="name"
                item-value="value"
                hide-details
                solo
                flat
                background-color="#efefef"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <p class="secondary--text pb-1">Pay Methods</p>
              <v-select
                v-model="dialogAddSubscription.subscription.billing.payMethod"
                :items="payMethodsList"
                item-text="name"
                item-value="value"
                hide-details
                solo
                flat
                background-color="#efefef"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <p class="secondary--text pb-1">Status Pay</p>
              <v-select
                v-model="dialogAddSubscription.subscription.billing.statusPay"
                :items="statusPaysList"
                item-text="name"
                item-value="value"
                hide-details
                solo
                flat
                background-color="#efefef"
              ></v-select>
            </v-col> -->
            <v-col cols="6">
              <p class="secondary--text pb-1">Subscription</p>
              <v-select
                v-model="dialogAddSubscription.selectedSubscription"
                :items="availableSubscriptions"
                item-text="name.ENG"
                item-value="value"
                hide-details
                return-object
                solo
                flat
                background-color="#efefef"
              ></v-select>
            </v-col>
            <v-col cols="12" v-if="dialogAddSubscription.selectedSubscription">
              <h3 class="secondary--text mt-2 d-inline">
                {{ dialogAddSubscription.selectedSubscription.name.ENG }}
              </h3>
              <h3 class="primary--text mt-2 d-inline">
                ({{
                  dialogAddSubscription.selectedSubscription.duration.quantity
                }}
                {{
                  dialogAddSubscription.selectedSubscription.duration.interval
                }})
              </h3>
              <p class="secondary--text pb-2">
                {{ dialogAddSubscription.selectedSubscription.description.ENG }}
              </p>
              <div>
                <h3 class="secondary--text mt-2 d-inline">Start Date:</h3>
                <p class="secondary--text pb-0 d-inline">{{ getFullDate() }}</p>
              </div>
              <h3 class="secondary--text mt-2 d-inline">End Date:</h3>
              <p class="secondary--text pb-0 d-inline">
                {{
                  getFullDate(
                    setFinishDaySubscription(
                      dialogAddSubscription.selectedSubscription.duration
                        .quantity,
                      dialogAddSubscription.selectedSubscription.duration
                        .interval
                    )
                  )
                }}
              </p>
            </v-col>
            <v-col cols="12" v-if="dialogAddSubscription.selectedSubscription">
              <v-btn
                color="primary"
                :loading="dialogAddSubscription.loading"
                :disabled="dialogAddSubscription.loading"
                class="float-right"
                @click="openDialogReAuth('addSubscriptionUser', {})"
              >
                Add subscription
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.snackbar"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      >{{ snackbar.text }}</v-snackbar
    >

    <modal-reauth
      :dialogReAuth="dialogReAuth"
      @isSuccessReAuth="isSuccessReAuth"
    ></modal-reauth>

    <v-dialog
      v-model="dialogAddFamilyMember.show"
      width="500"
      class="rounded-xl"
    >
      <v-card class="pa-5">
        <v-card-actions class="pa-0">
          <v-btn icon color="red" @click="closeDialogAddFamilyMember()">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <h3 class="secondary--text mt-2">
                Add Family Member to {{ user.firstName }} {{ user.lastName }}'s
                Subscription
              </h3>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="dialogAddFamilyMember.email"
                label="Family Member Email"
                type="email"
                :error-messages="dialogAddFamilyMember.error"
                @input="dialogAddFamilyMember.error = null"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                color="primary"
                :loading="dialogAddFamilyMember.loading"
                :disabled="
                  dialogAddFamilyMember.loading || !dialogAddFamilyMember.email
                "
                @click="addFamilyMember()"
              >
                Add Family Member
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRemoveFamilyMember.show"
      width="400"
      class="rounded-xl"
    >
      <v-card class="pa-5 d-flex flex-column justify-center align-center">
        <v-card-title class="headline text-center"
          >Remove Family Member</v-card-title
        >
        <v-card-text class="pa-8 text-center">
          Are you sure you want to remove
          <span class="font-weight-bold"
            >{{ dialogRemoveFamilyMember.member?.firstName }}
            {{ dialogRemoveFamilyMember.member?.lastName }}</span
          >
          ({{ dialogRemoveFamilyMember.member?.email }}) from the family
          subscription?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="third"
            tile
            width="100"
            class="pa-0 text--secondary"
            @click="closeDialogRemoveFamilyMember()"
            >Cancel</v-btn
          >
          <v-btn
            color="red"
            tile
            width="100"
            class="pa-0 ml-2"
            :loading="
              removingFamilyMemberId === dialogRemoveFamilyMember.member?.id
            "
            @click="confirmRemoveFamilyMember"
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle de resultado (mismo modal que usa el dashboard) -->
    <result-modal
      :show="resultModal.show"
      :result-id="resultModal.resultId"
      :result-user="resultUserForModal"
      :result-type="resultModal.resultType"
      :close="closeResultModal"
    />
  </v-container>
</template>
<script>
import moment from "moment";
import { doc, collection, getDoc } from "firebase/firestore";
import { getDb } from "@/firebase";
import Paths from "@/router/paths/index";
import { mapGetters } from "vuex";
import modalReauth from "@/components/admin/modal-reauth.vue";
import ResultModal from "@/components/admin/results/ResultModal.vue";
export default {
  name: "User",
  components: { modalReauth, ResultModal },
  data: () => ({
    user: {
      savesUser: {
        sessions: [],
      },
      metadata: {
        creationTime: "",
      },
      adminLevel: "",
      devicesInfo: [],
    },
    maxProDevices: [],
    subscriptionsGetted: [],
    receiptsHistory: [],
    expandedReceipts: [],
    aiChatProfile: null,
    loadingReceipts: false,
    receiptsError: "",
    achievementsGetted: [],
    allowedRoutes: [],
    availableSubscriptions: [],
    loadingCoach: false,
    snackbar: {
      snackbar: false,
      timeout: 2000,
      text: null,
      color: "",
    },
    dialogRole: {
      show: false,
      item: "",
    },
    dialog: {
      show: false,
      type: "",
      email: "",
      item: "",
    },
    dialogReAuth: {
      show: false,
      action: "",
      item: {},
      goActionProps: {},
    },
    dialogManageAllowedViews: {
      show: false,
    },
    dialogAddSubscription: {
      show: false,
      loading: false,
      subscription: {
        billing: {
          currency: "USD",
          offer: {
            inOffer: false,
            percentage: 0,
            priceInOffer: 0,
          },
          payMethod: "ADDED-MANUALLY",
          price: {
            USD: 0,
          },
          statusPay: "SUCCESS",
        },
        duration: {},
        isCoupon: true,
      },
      selectedSubscription: null,
    },
    dialogAddFamilyMember: {
      show: false,
      loading: false,
      email: "",
      error: null,
    },
    dialogRemoveFamilyMember: {
      show: false,
      member: null,
    },
    levelProps: [
      { level: "User", value: "" },
      { level: "Customer Service", value: 1 },
      { level: "Admin", value: 3 },
    ],
    search: "",
    headers: [
      {
        text: "Name",
        align: "center",
        value: "name",
        sortable: true,
      },
      {
        text: "Exercises",
        align: "center",
        value: "exercises",
        sortable: true,
      },
      {
        text: "Circuit Reps",
        align: "center",
        value: "circuitReps",
        sortable: true,
      },
    ],
    headersDevices: [
      {
        text: "Last Used",
        align: "center",
        value: "lastUsed",
        sortable: false,
      },
      {
        text: "App version",
        align: "center",
        value: "appVersion",
        sortable: true,
      },
      { text: "Device Name", align: "center", value: "name", sortable: true },
      { text: "OS", align: "center", value: "operatingSystem", sortable: true },
      {
        text: "OS version",
        align: "center",
        value: "osVersion",
        sortable: true,
      },
      {
        text: "Manufacturer",
        align: "center",
        value: "manufacturer",
        sortable: true,
      },
      { text: "Model", align: "center", value: "model", sortable: true },
    ],
    headersMaxProDevices: [
      { text: "MAC", align: "center", value: "maxproMac", sortable: false },
      { text: "Left Used", align: "center", value: "counterL", sortable: true },
      {
        text: "Right Used",
        align: "center",
        value: "counterR",
        sortable: true,
      },
    ],
    headersAchievementsEarned: [
      { text: "", align: "center", value: "image", sortable: false },
      { text: "Achievement", align: "center", value: "ref", sortable: true },
      {
        text: "Unlock Date",
        align: "center",
        value: "createdAt",
        sortable: true,
      },
    ],
    headersSubscriptions: [
      {
        text: "Name",
        align: "center",
        value: "typeSubscription.name.ENG",
        sortable: true,
      },
      {
        text: "Duration",
        align: "center",
        value: "duration.quantity",
        sortable: true,
      },
      {
        text: "Start Date",
        align: "center",
        value: "duration.startDate",
        sortable: true,
      },
      {
        text: "End Date",
        align: "center",
        value: "duration.endDate",
        sortable: true,
      },
      {
        text: "Pay Method",
        align: "center",
        value: "billing.payMethod",
        sortable: true,
      },
      {
        text: "Status Pay",
        align: "center",
        value: "billing.statusPay",
        sortable: true,
      },
      { text: "Active", align: "center", value: "isActive", sortable: true },
    ],
    headersReceipts: [
      { text: "Date", align: "center", value: "processedAt", sortable: true },
      { text: "App", align: "center", value: "app", sortable: true },
      { text: "Source", align: "center", value: "source", sortable: true },
      { text: "Result", align: "center", value: "result", sortable: true },
      { text: "Product", align: "center", value: "productId", sortable: false },
      { text: "Transaction", align: "center", value: "originalTransactionId", sortable: false },
      { text: "Error", align: "center", value: "errorDetails", sortable: false },
    ],
    currienciesList: [
      {
        name: "USD",
        value: "USD",
      },
    ],
    payMethodsList: [
      {
        name: "FREE",
        value: "FREE",
      },
      {
        name: "APPLE-PAY",
        value: "APPLE-PAY",
      },
      {
        name: "CREDIT-CARD",
        value: "CREDIT-CARD",
      },
      {
        name: "COUPON",
        value: "COUPON",
      },
      {
        name: "IN-APP-PURCHASE",
        value: "IN-APP-PURCHASE",
      },
    ],
    statusPaysList: [
      {
        name: "PENDING",
        value: "PENDING",
      },
      {
        name: "REJECTED",
        value: "REJECTED",
      },
      {
        name: "SUCCESS",
        value: "SUCCESS",
      },
    ],
    loading: false,
    isSubOwner: false,
    familyMembers: [],
    loadingFamilyMembers: false,
    headersFamilyMembers: [
      { text: "", align: "center", value: "photoURL", sortable: false },
      { text: "Name", align: "center", value: "firstName", sortable: true },
      { text: "Email", align: "center", value: "email", sortable: true },
      { text: "Actions", align: "center", value: "actions", sortable: false },
    ],
    removingFamilyMemberId: null,
    userResults: [],
    resultsAnalytics: null,
    loadingResults: false,
    headersResults: [
      { text: "Date", align: "center", value: "createdAt", sortable: true },
      { text: "Workout", align: "center", value: "name", sortable: false },
      { text: "Type", align: "center", value: "type", sortable: true },
      { text: "MXP", align: "center", value: "mxp", sortable: true },
      { text: "Calories", align: "center", value: "cals", sortable: true },
      { text: "Reps", align: "center", value: "totalReps", sortable: true },
      { text: "Distance (m)", align: "center", value: "totalDistance", sortable: true },
      { text: "Weight (kg)", align: "center", value: "totalWeight", sortable: true },
      { text: "", align: "center", value: "actions", sortable: false },
    ],
    resultModal: {
      show: false,
      resultId: "",
      resultType: undefined,
    },
  }),
  async created() {
    const vm = this;
    try {
      vm.$emit("showOverlay", true);
      await vm.getUser();
      await vm.getUserMaxProDevices();
      await vm.getThisUserSubscriptions();
      vm.getUserReceiptsHistory();
      vm.getAiChatProfile();
      await vm.getUserAchievements();
      await vm.getFamilyMembers();
      // Sin await: la CF de resultados puede tardar y la tabla tiene su propio loader
      vm.loadUserResults();
      vm.$emit("showOverlay", false);
    } catch (error) {
      console.error(error);
      vm.$emit("showOverlay", false);
    }
  },
  methods: {
    async getUser() {
      let vm = this;
      try {
        const user = await vm.$store.dispatch(
          "GetUserWithSubCollections",
          vm.$route.params.uid
        );
        vm.user = user;

        if (user.isPremium) {
          const web = user.activeSubscription.webSub === true;
          const isSubOwner = await vm.$store.dispatch("isSubOwner", {
            user: web ? user.email : vm.$route.params.uid,
            sub: web
              ? user.activeSubscription.lastReceipt
              : user.activeSubscription.ref,
            web,
          });
          vm.isSubOwner = isSubOwner;
        } else {
          vm.isSubOwner = false;
        }
        vm.$set(vm.user, "isCoach", user.isCoach ? true : false);
        vm.user.adminLevel = vm.user.adminLevel
          ? parseInt(vm.user.adminLevel, 10)
          : "";
      } catch (error) {
        console.error(error);
      }
    },
    async getUserMaxProDevices() {
      const vm = this;
      try {
        const maxProDevices = await vm.$store.dispatch(
          "GetUserMaxProDevices",
          vm.$route.params.uid
        );
        vm.maxProDevices = maxProDevices;
      } catch (error) {
        console.error(error);
      }
    },
    async getThisUserSubscriptions() {
      const vm = this;
      try {
        const subscriptionsGetted = await vm.$store.dispatch(
          "GetAllSubscriptionsUser",
          vm.$route.params.uid
        );
        
        vm.subscriptionsGetted = subscriptionsGetted;
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * El perfil del chat con Max no está en el documento del usuario sino en
     * users/{uid}/aiCoach/profile. Si falla, se deja en null y la sección
     * muestra todo como "missing": no vale la pena romper la vista entera por
     * esto.
     */
    async getAiChatProfile() {
      try {
        const snap = await getDoc(
          doc(getDb(), "users", this.$route.params.uid, "aiCoach", "profile")
        );
        this.aiChatProfile = snap.exists() ? snap.data() : null;
      } catch (error) {
        console.error("No se pudo leer el perfil del chat IA:", error);
        this.aiChatProfile = null;
      }
    },
    /** Lista del catálogo a texto. Vacía = el usuario eligió "ninguno". */
    formatList(valor) {
      if (!Array.isArray(valor)) return valor;
      if (valor.length === 0) return "none";
      return valor.join(", ");
    },
    async getUserReceiptsHistory() {
      const vm = this;
      vm.loadingReceipts = true;
      vm.receiptsError = "";
      try {
        vm.receiptsHistory = await vm.$store.dispatch(
          "GetUserReceiptsHistory",
          vm.$route.params.uid
        );
      } catch (error) {
        console.error(error);
        vm.receiptsHistory = [];
        vm.receiptsError = error && error.message
          ? error.message
          : "Could not load receipt history.";
      } finally {
        vm.loadingReceipts = false;
      }
    },
    receiptResultClass(result) {
      if (result === "success") return "success--text";
      if (result === "error") return "red--text";
      return "grey--text";
    },
    /**
     * Campos a mostrar al expandir un recibo del historial.
     *
     * Se listan TODOS los del documento menos las credenciales, en vez de una
     * lista fija: los campos de diagnóstico cambian seguido (StoreKit 2 y las
     * notificaciones V2 agregaron varios) y así aparecen solos, sin tener que
     * acordarse de actualizar esto.
     */
    receiptDetailFields(item) {
      // NUNCA mostrar estos. El recibo y el token son credenciales de
      // verificación: con ellos se puede validar contra la tienda haciéndose
      // pasar por la app. Si en el futuro se guarda otro dato así, va aquí.
      const credenciales = ["receiptData", "purchaseToken"];

      const etiquetas = {
        processedAt: "Processed at",
        completedAt: "Completed at",
        app: "Store",
        source: "Source",
        result: "Result",
        productId: "Product",
        originalTransactionId: "Original transaction",
        transactionId: "Transaction",
        storeKitVersion: "StoreKit version",
        notificationType: "Notification type",
        notificationSubtype: "Notification subtype",
        notificationUUID: "Notification UUID",
        verificationStatus: "Verification status",
        webhookProcessed: "Processed by webhook",
        usedFallback: "Used fallback",
        isExpired: "Expired",
        isCancelled: "Cancelled",
        errorDetails: "Error",
        reason: "Reason",
        userMarkedAsNonPremium: "Marked as non-premium",
        id: "History ID",
        userId: "User ID",
      };
      // Los conocidos van en este orden; lo que no esté listado cae al final.
      const orden = Object.keys(etiquetas);
      const posicion = (clave) => {
        const i = orden.indexOf(clave);
        return i === -1 ? orden.length : i;
      };

      return Object.keys(item || {})
        .filter((clave) => !credenciales.includes(clave))
        .sort((a, b) => posicion(a) - posicion(b))
        .map((clave) => {
          const crudo = item[clave];
          return {
            key: clave,
            label: etiquetas[clave] || clave,
            value: this.formatFieldValue(crudo),
            missing: this.isMissing(crudo),
          };
        });
    },
    /**
     * ¿Está sin configurar? Se distingue de los valores que SÍ significan algo:
     * `false` y `0` son configuración válida, no ausencia.
     */
    isMissing(valor) {
      if (valor === null || valor === undefined) return true;
      if (typeof valor === "string" && valor.trim() === "") return true;
      if (Array.isArray(valor) && valor.length === 0) return true;
      return false;
    },
    /**
     * El cumpleaños se guarda como ISO completo ("1990-08-05T17:23:58.000Z"),
     * pero la hora no significa nada: es el momento en que se tocó el campo.
     * Mostrarla entera estorba, así que se corta a la fecha.
     *
     * Se parte la cadena en vez de usar `new Date`, porque interpretarla en la
     * zona del navegador puede correr el día: un cumpleaños a las 00:30 UTC se
     * vería como el día anterior en México.
     */
    formatBirthday(valor) {
      if (this.isMissing(valor)) return valor;
      if (typeof valor === "string") {
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor);
        if (m) {
          const meses = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
          return `${meses[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}`;
        }
      }
      return valor;
    },
    /** Pasa cualquier valor de Firestore a algo legible en pantalla. */
    formatFieldValue(valor) {
      if (this.isMissing(valor)) return "missing";
      if (typeof valor === "boolean") return valor ? "yes" : "no";
      // Timestamp de Firestore, en cualquiera de sus dos formas
      if (
        typeof valor === "object" &&
        (valor.seconds !== undefined || typeof valor.toDate === "function")
      ) {
        return this.timestampToStringDate(valor);
      }
      if (Array.isArray(valor)) return `${valor.length} item(s)`;
      if (typeof valor === "object") return JSON.stringify(valor);
      return String(valor);
    },
    shortId(value) {
      if (!value || value === "unknown") return "—";
      if (value.length <= 18) return value;
      return `${value.slice(0, 8)}…${value.slice(-6)}`;
    },
    shortText(value) {
      if (!value) return "";
      return value.length > 80 ? `${value.slice(0, 80)}…` : value;
    },
    async getUserAchievements() {
      const vm = this;
      try {
        const achievementsGetted = await vm.$store.dispatch(
          "GetUserAchievements",
          vm.$route.params.uid
        );
        vm.achievementsGetted = achievementsGetted;
      } catch (error) {
        console.error(error);
      }
    },
    async getFamilyMembers() {
      const vm = this;
      try {
        vm.loadingFamilyMembers = true;
        const familyMembers = await vm.$store.dispatch(
          "GetFamilyMembers",
          vm.$route.params.uid
        );
        vm.familyMembers = familyMembers;
      } catch (error) {
        console.error("Error fetching family members:", error);
        vm.snackbar.text = "Error fetching family members";
        vm.snackbar.color = "error";
        vm.snackbar.snackbar = true;
      } finally {
        vm.loadingFamilyMembers = false;
      }
    },
    async loadUserResults() {
      const vm = this;
      try {
        vm.loadingResults = true;
        const data = await vm.$store.dispatch("getUserResultsByRange", {
          userId: vm.$route.params.uid,
        });
        vm.userResults = data?.orderedResults || [];
        vm.resultsAnalytics = data?.analyticsData || null;
      } catch (error) {
        console.error("Error fetching workout results:", error);
        vm.snackbar.text = "Error fetching workout results";
        vm.snackbar.color = "error";
        vm.snackbar.snackbar = true;
      } finally {
        vm.loadingResults = false;
      }
    },
    /** Mapea el restype del resultado al type que espera getResultData. */
    resultTypeForModal(item) {
      switch (item.restype || item.resType) {
        case "coachedClass":
          return "coachedClass";
        case "live":
        case "lives":
          return "live";
        case "preSet":
          return "preSet";
        case "byo":
          return "byo";
        case "freestyle":
        case "freeStyle":
          return "Freestyle";
        default:
          return undefined;
      }
    },
    openResultModal(item) {
      this.resultModal.resultType = this.resultTypeForModal(item);
      this.resultModal.resultId = item.id;
      this.resultModal.show = true;
    },
    closeResultModal() {
      this.resultModal.show = false;
      this.resultModal.resultId = "";
      this.resultModal.resultType = undefined;
    },
    getResultName(item) {
      // Los nombres pueden venir como string o como objeto i18n { ENG: ... }
      const pick = (value) => {
        if (typeof value === "string") return value;
        if (value && typeof value === "object") return value.ENG || "";
        return "";
      };
      switch (item.restype || item.resType) {
        case "coachedClass":
          return pick(item.training?.name) || item.trainName || "Coached Class";
        case "live":
        case "lives":
          return pick(item.training?.title) || "Live";
        case "preSet":
          return pick(item.session?.name) || "Pre-Set";
        case "byo":
          return pick(item.session?.name) || "BYO";
        default:
          return pick(item.name) || "FreeStyle";
      }
    },
    formatResultDate(createdAt) {
      if (!createdAt) return "";
      return moment(createdAt).format("MMM D, YYYY h:mm A");
    },
    formatResultNumber(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return "0";
      return Number.isInteger(n) ? String(n) : n.toFixed(1);
    },
    formatResultTime(totalSeconds) {
      const seconds = Number(totalSeconds) || 0;
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
    },
    isSuccessReAuth(dialogReAuthResponse) {
      const vm = this;
      switch (dialogReAuthResponse.action) {
        case "goActionMail":
          vm.goActionMail(
            dialogReAuthResponse.goActionProps.type,
            dialogReAuthResponse.goActionProps.email,
            dialogReAuthResponse.goActionProps.item
          );
          break;
        case "updateRoleUser":
          vm.updateRoleUser(dialogReAuthResponse.item);
          break;
        case "addSubscriptionUser":
          vm.addSubscriptionUser();
          break;
        default:
          break;
      }
    },
    openDialogReAuth(action, item, goActionProps) {
      let vm = this;
      vm.dialogReAuth.show = true;
      vm.dialogReAuth.action = action;
      vm.dialogReAuth.item = item;
      vm.dialogReAuth.goActionProps = goActionProps;
      vm.closeModal();
    },
    openModal(type, email, item) {
      let vm = this;
      vm.dialog.show = true;
      vm.dialog.type = type;
      vm.dialog.email = email;
      vm.dialog.item = item;
    },
    closeModal() {
      let vm = this;
      vm.dialog.show = false;
      vm.dialog.type = "";
      vm.dialog.email = "";
      vm.dialog.item = "";

      vm.dialogRole.show = false;
      vm.dialogRole.item = "";
    },
    goActionMail(type, email, item) {
      let vm = this;
      vm.$emit("showOverlay", true);
      if (type == "validate") {
        let verificationData = {
          email: email,
          lang: item.lang,
          displayName: `${item.firstName ? item.firstName : ""} ${
            item.lastName ? item.lastName : ""
          }`,
        };
        vm.closeModal();
        vm.$store
          .dispatch("SendVerificationEmail", verificationData)
          .then((res) => {
            vm.$store.dispatch("GenerateLog", {
              user: verificationData.email,
              type: "validationEmail",
            });
            vm.snackbar.text = "Mail sended!";
            vm.snackbar.color = "green";
            vm.snackbar.snackbar = true;
            vm.$emit("showOverlay", false);
          })
          .catch((err) => {
            vm.snackbar.text = "Error sending mail!";
            vm.snackbar.color = "red";
            console.error(err);
            vm.$emit("showOverlay", false);
            vm.snackbar.snackbar = true;
          });
      } else if (type == "restore") {
        let resetPasswordData = {
          email: email,
          lang: item.lang,
          displayName: `${item.firstName ? item.firstName : ""} ${
            item.lastName ? item.lastName : ""
          }`,
        };
        vm.closeModal();
        vm.$store
          .dispatch("SendPasswordResetEmail", resetPasswordData)
          .then((res) => {
            vm.$store.dispatch("GenerateLog", {
              user: resetPasswordData.email,
              type: "restorePassword",
            });
            vm.snackbar.text = "Mail sended!";
            vm.snackbar.color = "green";
            vm.snackbar.snackbar = true;

            vm.$emit("showOverlay", false);
          })
          .catch((err) => {
            vm.snackbar.text = "Error sending mail!";
            vm.snackbar.color = "red";
            vm.snackbar.snackbar = true;
            vm.$emit("showOverlay", false);
          });
      } else if (type === "disable") {
        // let index = vm.users.indexOf(item);
        vm.disableUser(item);
      }
    },
    openDialogManageAllowedViews() {
      let vm = this;
      if (vm.user.adminLevel != "" && vm.user.allowedRoutes) {
        vm.allowedRoutes = vm.user.allowedRoutes;
      } else {
        vm.user.allowedRoutes = [];
      }
      vm.dialogManageAllowedViews.show = true;
    },
    closeDialogManageAllowedViews() {
      let vm = this;
      vm.dialogManageAllowedViews.show = false;
    },
    updateViewsAllowed() {
      let vm = this;
      vm.closeDialogManageAllowedViews();
      vm.$emit("showOverlay", true);
      vm.$store
        .dispatch("UpdateViewsAllowed", {
          uid: vm.user.uid,
          allowedRoutes: vm.allowedRoutes,
        })
        .then((res) => {
          vm.user.allowedRoutes = res;
          vm.snackbar.text = `Allowed routes updated successfully`;
          vm.snackbar.color = "success";
          vm.$emit("showOverlay", false);
          vm.snackbar.snackbar = true;
        })
        .catch((err) => {
          vm.snackbar.text = `Error disabling user`;
          vm.snackbar.color = "red darken-2";
          vm.$emit("showOverlay", false);
          vm.snackbar.snackbar = true;
        });
    },
    async openDialogAddSubscription() {
      const vm = this;
      await vm.getAllSubscriptions();
      vm.dialogAddSubscription.show = true;
    },
    closeDialogAddSubscription() {
      const vm = this;
      vm.dialogAddSubscription = {
        show: false,
        loading: false,
        subscription: {
          billing: {
            currency: "USD",
            offer: {
              inOffer: false,
              percentage: 0,
              priceInOffer: 0,
            },
            payMethod: "ADDED-MANUALLY",
            price: {
              USD: 0,
            },
            statusPay: "SUCCESS",
          },
          duration: {},
          isCoupon: true,
        },
        selectedSubscription: null,
      };
    },
    async getAllSubscriptions() {
      const vm = this;
      try {
        const subscriptions = await vm.$store.dispatch("GetSubscriptionsList");
        vm.availableSubscriptions = subscriptions;
      } catch (error) {
        console.error(error);
      }
    },
    setFinishDaySubscription(quantity, interval) {
      const changedDate = moment().add(quantity, interval);
      return changedDate.toDate();
    },
    async addSubscriptionUser() {
      const vm = this;
      try {
        vm.dialogAddSubscription.loading = true;
        let dialog = vm.dialogAddSubscription;
        let payload = {
          billing: {
            currency: dialog.subscription.billing.currency,
            offer: dialog.selectedSubscription.offer,
            payMethod: dialog.subscription.billing.payMethod,
            price: dialog.selectedSubscription.price,
            statusPay: dialog.subscription.billing.statusPay,
          },
          duration: {
            startDate: new Date(),
            endDate: vm.setFinishDaySubscription(
              dialog.selectedSubscription.duration.quantity,
              dialog.selectedSubscription.duration.interval
            ),
            quantity: dialog.selectedSubscription.duration.quantity,
            interval: dialog.selectedSubscription.duration.interval,
          },
          isCoupon: true,
          typeSubscription: dialog.selectedSubscription.id,
          user: vm.user.uid,
        };

        const id = await vm.$store.dispatch("AddSubscriptionToUser", payload);
        await vm.$store.dispatch("GenerateLog", {
          id: id,
          name: dialog.selectedSubscription.name["ENG"],
          user: vm.user.uid,
          type: "addedManuallySubscriptionToUser",
        });
        vm.user.activeSubscription = {
          ref: doc(getDb(), "subscriptionsGettedByUsers", id),
          isPremium: dialog.selectedSubscription.id !== "Yn8R3ywqutpbFmyPoAbt",
        };
        await vm.getThisUserSubscriptions();
        vm.dialogAddSubscription.loading = false;
        vm.closeDialogAddSubscription();
        let emitData = {
          snackbar: true,
          btn: "",
          y: "bottom",
          x: null,
          mode: "",
          timeout: 2000,
          text: "Subscription added to user successfully",
          color: "success",
        };
        vm.$emit("showSnackBar", emitData);
      } catch (error) {
        vm.dialogAddSubscription.loading = false;
          console.error(error);
        let emitData = {
          snackbar: true,
          btn: "",
          y: "bottom",
          x: null,
          mode: "",
          timeout: 2000,
          text: "Error adding Subscription to user",
          color: "red",
        };
        vm.$emit("showSnackBar", emitData);
      }
    },
    goBack() {
      let vm = this;
      vm.$store.dispatch("ResetValues");
      vm.$router.go(-1);
    },
    getRoutesNames() {
      const routesNames = Paths.map((route) => route.name);
      return routesNames;
    },
    disableUser(user) {
      let vm = this;
      vm.closeModal();

      if (!user.adminLevel) {
        vm.$store
          .dispatch("DisableUser", {
            uid: user.uid,
            valueDisabled: !user.disabled,
          })
          .then((res) => {
            vm.user.disabled = res.disabled;

            vm.$store.dispatch("GenerateLog", {
              user: vm.user.email,
              type: vm.user.disabled ? "disabled" : "enabled",
            });

            vm.snackbar.text = `User ${
              res.disabled ? "disabled" : "enabled"
            } successfully`;
            vm.snackbar.color = "green";
            vm.$emit("showOverlay", false);
            vm.snackbar.snackbar = true;
          })
          .catch((err) => {
            console.error(err);
            vm.snackbar.text = `Error disabling user`;
            vm.snackbar.color = "red darken-2";
            vm.$emit("showOverlay", false);
            vm.snackbar.snackbar = true;
          });
      } else {
        vm.$emit("showOverlay", false);
        vm.snackbar.text = `You can't disable the admin`;
        vm.snackbar.color = "red darken-2";
        vm.snackbar.snackbar = true;
      }
    },
    getParsedDate(date) {
      if (date) {
        return moment(date).format("MM/DD/YYYY");
      }
    },
    getFullDate(date) {
      if (date) {
        return moment(date).format("MMMM Do YYYY, h:mm:ss a");
      } else {
        return moment(new Date()).format("MMMM Do YYYY, h:mm:ss a");
      }
    },
    timestampToStringDate(timestamp) {
      let dateParsed;
      
      if (timestamp && timestamp.seconds) {
        // Firestore Timestamp
        dateParsed = new Date(timestamp.seconds * 1000);
      } else if (timestamp && timestamp.toDate) {
        // Firestore Timestamp con método toDate()
        dateParsed = timestamp.toDate();
      } else if (timestamp) {
        // JavaScript Date o string ISO
        dateParsed = new Date(timestamp);
      } else {
        // Fallback
        dateParsed = new Date();
      }
      
      return moment(dateParsed).format("MMMM Do YYYY, h:mm:ss a");
    },
    calculateDurationFromDates(startDate, endDate) {
      try {
        let start, end;
        
        // Procesar startDate
        if (startDate && startDate.seconds) {
          start = moment(new Date(startDate.seconds * 1000));
        } else if (startDate && startDate.toDate) {
          start = moment(startDate.toDate());
        } else if (startDate) {
          start = moment(new Date(startDate));
        } else {
          return "Invalid start";
        }
        
        // Procesar endDate
        if (endDate && endDate.seconds) {
          end = moment(new Date(endDate.seconds * 1000));
        } else if (endDate && endDate.toDate) {
          end = moment(endDate.toDate());
        } else if (endDate) {
          end = moment(new Date(endDate));
        } else {
          return "Invalid end";
        }
        
        // Calcular diferencia
        const duration = moment.duration(end.diff(start));
        const days = Math.floor(duration.asDays());
        const months = Math.floor(duration.asMonths());
        const years = Math.floor(duration.asYears());
        
        if (years >= 1) {
          return `${years} year${years > 1 ? 's' : ''}`;
        } else if (months >= 1) {
          return `${months} month${months > 1 ? 's' : ''}`;
        } else if (days >= 1) {
          return `${days} day${days > 1 ? 's' : ''}`;
        } else {
          return "< 1 day";
        }
      } catch (error) {
        console.error('Error calculating duration:', error);
        return "Error";
      }
    },
    changeRouteSendNotification() {
      let vm = this;
      vm.$router
        .push({ name: "Push Notification Send", params: vm.user })
        .catch((err) => {
          vm.snackbar.text =
            "Sorry, you don't have permissions to enter this view.";
          vm.snackbar.color = "red darken-2";
          vm.snackbar.snackbar = true;
        });
    },
    changeRange(value) {
      let vm = this;
      vm.dialogRole.show = true;
      vm.dialogRole.item = value;
      // vm.openModal('role', vm.user.email, value)
    },
    closeModalRole() {
      let vm = this;
      // vm.user.adminLevel = vm.dialogRole.beforeValue
      vm.$refs.selectRole.lazyValue = vm.user.adminLevel;
      vm.$refs.selectRole.value = vm.user.adminLevel;
      vm.dialogRole.show = false;
      vm.dialogRole.item = "";
    },
    updateRoleUser(changedValue) {
      let vm = this;
      vm.$store
        .dispatch("ChangeRoleUser", {
          uid: vm.user.uid,
          adminLevel: changedValue,
          allowedRoutes: vm.user.allowedRoutes,
        })
        .then((res) => {
          let role = vm.levelProps.find((r) => r.value === changedValue);

          vm.$store.dispatch("GenerateLog", {
            user: vm.user.email,
            type: "updateUserRole",
            role: role.level,
          });
          vm.user.adminLevel = changedValue;
          vm.snackbar.text = "User level changed successfuly!";
          vm.snackbar.color = "green";
          vm.snackbar.snackbar = true;
        })
        .catch((err) => {
          vm.snackbar.text = "Error changing level";
          vm.snackbar.color = "red";
          vm.snackbar.snackbar = true;
          console.error(err);
          vm.$refs.selectRole.lazyValue = vm.user.adminLevel;
          vm.$refs.selectRole.value = vm.user.adminLevel;
        });
    },
    getTimeWorkouts(workOuts) {
      if (workOuts) {
        let totalTime = 0;
        for (let i = 0; i < workOuts.length; i++) {
          totalTime = totalTime + workOuts[i].timeWorkout.minutes * 60;
          totalTime = totalTime + workOuts[i].timeWorkout.seconds;
        }
        let parserTime = moment.duration(totalTime, "seconds");
        if (totalTime < 60) {
          return `${parserTime.get("seconds")} seconds`;
        } else if (totalTime >= 60 && totalTime < 3600) {
          return `${parserTime.get("minutes")} minutes ${parserTime.get(
            "seconds"
          )} seconds`;
        } else if (totalTime >= 3600) {
          return `${parserTime.get("hours")} hours ${parserTime.get(
            "minutes"
          )} minutes ${parserTime.get("seconds")} seconds`;
        }
      }
    },
    getCalsWorkouts(workOuts) {
      let totalCals = 0;
      for (let i = 0; i < workOuts.length; i++) {
        totalCals = totalCals + workOuts[i].cals;
      }
      return totalCals.toFixed(2);
    },
    getExercisesMadedWorkouts(workOuts) {
      let totalExercises = 0;
      for (let i = 0; i < workOuts.length; i++) {
        totalExercises = totalExercises + workOuts[i].exercisesMaded;
      }
      return totalExercises;
    },
    rangeDates(workOuts) {
      const dates = [];
      for (let i = 0; i < workOuts.length; i++) {
        dates.push(workOuts[i].createdAt._seconds * 1000);
      }
              const minDate = moment(new Date(Math.min(...dates))).format("DD/MM/YYYY");
        const maxDate = moment(new Date(Math.max(...dates))).format("DD/MM/YYYY");

      return { minDate, maxDate };
    },
    getTimeWorkoutsProTrainers() {
      let vm = this;
      let workOuts = vm.user.savesUser.proTrainingSaves;
      if (workOuts) {
        let totalTime = 0;
        for (let i = 0; i < workOuts.length; i++) {
          totalTime =
            totalTime + moment.duration(workOuts[i].totalTime).asSeconds();
        }
        let parserTime = moment.duration(totalTime, "seconds");
        if (totalTime < 60) {
          return `${parserTime.get("seconds")} seconds`;
        } else if (totalTime >= 60 && totalTime < 3600) {
          return `${parserTime.get("minutes")} minutes ${parserTime.get(
            "seconds"
          )} seconds`;
        } else if (totalTime >= 3600) {
          return `${parserTime.get("hours")} hours ${parserTime.get(
            "minutes"
          )} minutes ${parserTime.get("seconds")} seconds`;
        }
      }
    },
    verifyPrivilege() {
      const vm = this;
      // return 'asda'
      return vm.user.activeSubscription && vm.user.activeSubscription.isPremium
        ? "Premium"
        : vm.user.creationTime &&
          vm.user.creationTime?.toDate() <= new Date("2021-12-07")
        ? "GrandFathered"
        : "Free";
    },
    async changeCoachStatus() {
      const vm = this;
      try {
        vm.loadingCoach = true;
        const id = await vm.$store.dispatch("ChangeStateCoach", {
          uid: vm.user.uid,
          isCoach: vm.user.isCoach,
        });
        vm.$store.dispatch("GenerateLog", {
          id,
          email: vm.user.email,
          type: "updateCoachStatus",
          isCoach: vm.user.isCoach,
        });
        vm.snackbar.text = "Coach status changed successfuly";
        vm.snackbar.color = "green";
        vm.snackbar.snackbar = true;
        vm.loadingCoach = false;
      } catch (error) {
        vm.loadingCoach = false;
        vm.snackbar.text = "An error occurred when changing the coach's status";
        vm.snackbar.color = "red";
        vm.snackbar.snackbar = true;
        console.error(error);
      }
    },
    openDialogAddFamilyMember() {
      const vm = this;
      vm.dialogAddFamilyMember = {
        show: true,
        loading: false,
        email: "",
        error: null,
      };
    },
    closeDialogAddFamilyMember() {
      const vm = this;
      vm.dialogAddFamilyMember = {
        show: false,
        loading: false,
        email: "",
        error: null,
      };
    },
    async addFamilyMember() {
      const vm = this;
      try {
        vm.dialogAddFamilyMember.loading = true;
        vm.dialogAddFamilyMember.error = null;

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(vm.dialogAddFamilyMember.email)) {
          vm.dialogAddFamilyMember.error = "Please enter a valid email address";
          return;
        }

        // Add family member logic here
        await vm.$store.dispatch("AddFamilyMember", {
          userId: vm.$route.params.uid,
          familyMemberEmail: vm.dialogAddFamilyMember.email,
        });

        // Generate log
        // await vm.$store.dispatch("GenerateLog", {
        //   user: vm.user.email,
        //   type: "addFamilyMember",
        //   familyMemberEmail: vm.dialogAddFamilyMember.email
        // });

        vm.closeDialogAddFamilyMember();
        vm.getFamilyMembers();
        vm.snackbar.text = "Family member added successfully";
        vm.snackbar.color = "success";
        vm.snackbar.snackbar = true;
      } catch (error) {
        console.error("ERROR: ", error);
        vm.dialogAddFamilyMember.error =
          error.message || "Error adding family member";
        vm.snackbar.text = "Error adding family member";
        vm.snackbar.color = "error";
        vm.snackbar.snackbar = true;
      } finally {
        vm.dialogAddFamilyMember.loading = false;
      }
    },
    openDialogRemoveFamilyMember(member) {
      this.dialogRemoveFamilyMember = {
        show: true,
        member,
      };
    },
    closeDialogRemoveFamilyMember() {
      this.dialogRemoveFamilyMember = {
        show: false,
        member: null,
      };
    },
    async confirmRemoveFamilyMember() {
      const vm = this;
      const member = vm.dialogRemoveFamilyMember.member;
      try {
        vm.removingFamilyMemberId = member.id;
        await vm.$store.dispatch("RemoveFamilyMember", {
          web: vm.user.activeSubscription.webSub,
          familyMemberId: member.id,
        });
        await vm.getFamilyMembers();
        vm.snackbar.text = "Family member removed successfully";
        vm.snackbar.color = "success";
        vm.snackbar.snackbar = true;
      } catch (error) {
        vm.snackbar.text = "Error removing family member";
        vm.snackbar.color = "error";
        vm.snackbar.snackbar = true;
      } finally {
        vm.removingFamilyMemberId = null;
        vm.closeDialogRemoveFamilyMember();
      }
    },
  },
  computed: {
    ...mapGetters(["getAdmin"]),
    /**
     * Todo lo que el usuario configuró en la app, en el orden en que tiene
     * sentido leerlo: identidad, cuerpo, metas, app, estado.
     *
     * Varios campos se guardan como número y no dicen nada en crudo, así que se
     * traducen (gender, fitnessLevel). Las medidas se muestran en el sistema que
     * el usuario eligió: `imperialMeasurement` decide si lo suyo son los campos
     * en cm/kg o los de pies/libras, y mostrar el otro par sería ruido.
     */
    profilePreferences() {
      const u = this.user || {};
      const chat = this.aiChatProfile || {};
      const imperial = u.imperialMeasurement === true;

      // Mismos nombres que ve el usuario en la app, para que al reportar algo
      // ("mi objetivo es Burn Fat") coincida con lo que se ve aquí.
      const objetivos = { 1: "Burn Fat", 2: "Tone (Combo/Fusion)", 3: "Build Muscle" };
      const niveles = {
        1: "Elite (6 - 7 days)",
        2: "Serious (3 - 5 days)",
        3: "Casual (1 - 2 days)",
        4: "Starter",
      };
      const generos = { 1: "Female", 2: "Male" };

      // Agrupado igual que la pantalla de perfil de la app: About you, Weekly
      // goals y Chat preferences. Así lo que reporta un usuario se encuentra
      // en el mismo lugar.
      //
      // Los valores van CRUDOS; formatFieldValue decide cómo pintarlos y
      // isMissing si van como "missing". Así `false` y `0` no se confunden con
      // "sin configurar", que es el error fácil de cometer aquí.
      const grupos = [
        {
          title: "About you",
          fields: [
            ["firstName", "First name", u.firstName],
            ["lastName", "Last name", u.lastName],
            ["nickname", "Nickname", u.nickname],
            // En la app este campo se llama "Goal"; en Firestore es `challenge`.
            ["challenge", "Goal", objetivos[u.challenge] || u.challenge],
            ["fitnessLevel", "Fitness level", niveles[u.fitnessLevel] || u.fitnessLevel],
            ["units", "System", u.imperialMeasurement === undefined ? undefined : imperial ? "Imperial (lbs, ft/in)" : "Metric (kg, cm)"],
            ["gender", "Gender", generos[u.gender] || u.gender],
            ["birthday", "Birthday", this.formatBirthday(u.birthday)],
            // Solo el sistema que el usuario eligió; el otro par sería ruido.
            ["height", "Height", imperial
              ? (u.heightFeets === undefined && u.heightInches === undefined
                  ? undefined
                  : `${u.heightFeets || 0} ft ${u.heightInches || 0} in`)
              : (u.height === undefined ? undefined : `${u.height} cm`)],
            ["weight", "Weight", imperial
              ? (u.weightLbs === undefined ? undefined : `${u.weightLbs} lb`)
              : (u.weight === undefined ? undefined : `${u.weight} kg`)],
            ["country", "Country", u.country],
            ["lang", "Language", u.lang],
            ["timezone", "Timezone", u.timezone],
          ],
        },
        {
          title: "Account & status",
          fields: [
            ["instructor", "Instructor", u.instructor],
            ["bestMXP", "Best MXP", u.bestMXP],
            ["socialAgreement", "Social agreement", u.socialAgreement],
            ["isGrandFathered", "Grandfathered", u.isGrandFathered],
            ["firstTimeInApp", "First time in app", u.firstTimeInApp],
            ["lastActive", "Last active", u.lastActive],
          ],
        },
        {
          title: "Weekly goals",
          fields: [
            ["weeklyWorkoutDays", "Workout days", u.weeklyWorkoutDays],
            ["weeklyWorkoutMinutes", "Workout minutes", u.weeklyWorkoutMinutes],
            ["weeklyWeightLiftedGoal", "Weight lifted goal", imperial
              ? (u.weeklyWeightLiftedGoalLbs === undefined ? undefined : `${u.weeklyWeightLiftedGoalLbs} lb`)
              : (u.weeklyWeightLiftedGoalKg === undefined ? undefined : `${u.weeklyWeightLiftedGoalKg} kg`)],
            ["weeklyMxpGoal", "MXP goal", u.weeklyMxpGoal],
          ],
        },
        {
          // Vive aparte del documento del usuario: users/{uid}/aiCoach/profile.
          // Lo llena la conversación con Max, no la pantalla de perfil, aunque
          // objetivo, nivel y días se heredan de arriba para no tener dos
          // verdades.
          title: "Chat preferences (Max)",
          fields: [
            ["chatGoal", "Goal", chat.goal],
            ["experienceLevel", "Experience level", chat.experienceLevel],
            ["daysPerWeek", "Days per week", chat.daysPerWeek],
            ["minutesPerSession", "Minutes per session", chat.minutesPerSession],
            ["equipment", "Equipment", this.formatList(chat.equipment)],
            ["workoutTypes", "Workout types", this.formatList(chat.workoutTypes)],
            ["injuries", "Injuries", chat.injuries],
            ["dietaryRestrictions", "Dietary restrictions", this.formatList(chat.dietaryRestrictions)],
            ["allergies", "Allergies", chat.allergies],
            ["chatUpdatedAt", "Last updated", chat.updatedAt],
          ],
        },
      ];

      return grupos.map((grupo) => ({
        title: grupo.title,
        fields: grupo.fields.map(([key, label, valor]) => ({
          key,
          label,
          value: this.formatFieldValue(valor),
          missing: this.isMissing(valor),
        })),
      }));
    },
    /** Usuario que consume ResultModal (getResultData espera user.id). */
    resultUserForModal() {
      return { ...this.user, id: this.$route.params.uid };
    },
    /** Filas planas para el CSV (mismas columnas que la tabla). */
    resultsCsvData() {
      return this.userResults.map((item) => ({
        id: item.id,
        date: this.formatResultDate(item.createdAt),
        workout: this.getResultName(item),
        type: item.type || "",
        mxp: this.formatResultNumber(item.mxp),
        calories: this.formatResultNumber(item.cals),
        reps: item.totalReps || 0,
        distance_m: this.formatResultNumber(item.totalDistance),
        weight_kg: this.formatResultNumber(item.totalWeight),
      }));
    },
    resultsCsvTitle() {
      const who = this.user.email || this.$route.params.uid;
      return `workout_results_${who}_${moment().format("YYYY-MM-DD")}`;
    },
    /** Tarjetas de totales all-time (mismos acumuladores que la app). */
    resultsSummaryCards() {
      const a = this.resultsAnalytics;
      if (!a) return [];
      return [
        { label: "MXP", value: a.totalMXP },
        { label: "Calories", value: a.totalCalories },
        { label: "Time", value: this.formatResultTime(a.totalTime) },
        { label: "Reps", value: a.totalReps },
        { label: "Distance (m)", value: this.formatResultNumber(a.totalDistance) },
        { label: "Weight (kg)", value: a.totalWeight },
      ];
    },
  },
};
</script>

<style lang="scss">
.avatar-profile-image {
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center center;
  object-fit: contain;
}
.v-data-table ::v-deep .sticky-header {
  position: sticky;
  top: var(--toolbarHeight);
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow: unset;
}

.results-table tbody tr {
  cursor: pointer;
}
/* Las cuatro tarjetas en una sola fila, todas de la misma altura. Grid y no
   columnas CSS porque aquí importa el orden de lectura (izquierda a derecha),
   que las cuatro queden al mismo ancho, y poder igualarlas de alto.

   El alto parejo sale del `stretch` por defecto del grid más el `height: 100%`
   de la tarjeta; las cortas (Weekly goals son 4 filas) crecen hasta la más
   alta (About you son 13). */
.prefs-columns {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media (min-width: 600px) {
  .prefs-columns {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1264px) {
  .prefs-columns {
    grid-template-columns: repeat(4, 1fr);
  }
}
.prefs-card {
  /* `min-width: 0` deja que la tarjeta se encoja: sin esto una columna de grid
     no baja del ancho de su contenido y las cuatro se desbordan. */
  min-width: 0;
  /* Llena la altura que el grid le asignó, que es la de la tarjeta más alta. */
  height: 100%;
}
.prefs-label {
  flex: 0 0 auto;
  width: 130px;
  padding-right: 8px;
}
.prefs-value {
  /* Con cuatro tarjetas el valor queda angosto, así que tiene que envolver en
     vez de empujar la tarjeta. */
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
}
.prefs-row-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>